import { useParams, Link, Navigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SERVICES, SERVICE_GROUPS } from "@/data/site";

const get = (slug) => SERVICES.find((s) => s.slug === slug);

export default function PillarPage({ group: groupProp }) {
  const { group: groupParam } = useParams();
  const key = (groupProp || groupParam || "").toUpperCase();
  const g = SERVICE_GROUPS[key];
  if (!g) return <Navigate to="/404" replace />;

  return (
    <Layout>
      <Seo title={`${g.label} — Portugal Services | Effizent Europe`} description={g.blurb} />
      <PageHero eyebrow={`Pillar · ${g.label}`} title={g.label} subtitle={g.blurb} crumbs={[{ label: g.label }]} />

      <div className="max-w-6xl mx-auto px-6 md:px-8 py-20 grid gap-5 md:grid-cols-2">
        {g.slugs.map((slug, i) => {
          const s = get(slug);
          const Icon = Icons[s.icon] || Icons.Sparkles;
          return (
            <Reveal key={slug} delay={i * 0.06}>
              <Link
                to={`/services/${slug}`}
                data-testid={`pillar-service-${slug}`}
                className="group flex flex-col h-full rounded-3xl bg-white border border-navy/10 p-8 hover:border-gold/50 hover:shadow-xl hover:-translate-y-1 transition-all duration-500"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy text-gold group-hover:scale-110 transition-transform"><Icon className="h-7 w-7" strokeWidth={1.4} /></span>
                  <ArrowRight className="h-5 w-5 text-navy/25 group-hover:text-gold group-hover:translate-x-1 transition-all" />
                </div>
                <h3 className="font-playfair text-2xl text-navy mt-6">{s.title}</h3>
                <p className="text-terracotta text-sm mt-1">{s.tagline}</p>
                <p className="text-navy/60 mt-4 leading-relaxed flex-1">{s.summary}</p>
                <div className="mt-6 flex gap-4 text-xs text-navy/45">
                  <span>{s.duration}</span><span>·</span><span>{s.cost}</span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </Layout>
  );
}
